export default __webpack_public_path__ + "static/media/Fall vase 1.b5a9f5ee.jpg";